interface PhotoDisplayNameInput {
  displayName?: string | null;
  description?: string | null;
  fileName?: string | null;
}

export function getPhotoDisplayName({
  displayName,
  description,
  fileName,
}: PhotoDisplayNameInput): string {
  return displayName?.trim() || description?.trim() || fileName?.trim() || "";
}